// src/features/tasks/components/TaskListPage/TasksDataGrid/constants/columnDefinitions.js
import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import i18n from '../../../../../../i18n';
import PriorityCell from '../components/PriorityCell';
import StateCell from '../components/StateCell';
import CategoryCell from '../components/CategoryCell';
import AssigneeCell from '../components/AssigneeCell';
import DateCell from '../components/DateCell';
import DeadlineCell from '../components/DeadlineCell';
import ActionsCell from '../components/ActionsCell';
import { Loop, Repeat } from '@mui/icons-material';

export const createColumns = ({
  canUpdate,
  canDelete,
  canChangeState,
  onView,
  onEdit,
  onDelete,
  onStateChange,
  getTaskSortPriority,
}) => {
  const t = i18n.t.bind(i18n);

  return [
    {
      field: 'sort_priority',
      headerName: t('tasks:data_grid.columns.priority_order'),
      flex: 0.65,
      type: 'number',
      valueGetter: (value, row) => getTaskSortPriority(row),
      renderCell: (params) => {
        const priorityLabels = {
          1: t('tasks:data_grid.priority_labels.overdue'),
          2: t('tasks:data_grid.priority_labels.in_progress'),
          3: t('tasks:data_grid.priority_labels.pending'),
          4: t('tasks:data_grid.priority_labels.on_hold'),
          5: t('tasks:data_grid.priority_labels.scheduled'),
          6: t('tasks:data_grid.priority_labels.completed'),
          7: t('tasks:data_grid.priority_labels.cancelled')
        };
        return priorityLabels[params.value] || t('tasks:data_grid.priority_labels.unknown');
      }
    },
    {
      field: 'title',
      headerName: t('tasks:data_grid.columns.title'),
      flex: 3,
      minWidth: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
          <Tooltip title={(
            <Typography component="h4">
              {params.value}
            </Typography>
          )}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {params.row.is_recurring && (
                  <Loop fontSize="large" sx={{ color: 'success.main' }} />
                )}
                <Typography variant="h4" fontWeight="medium" noWrap>
                  {params.value}
                </Typography>
              </Box>
              {params.row.description ? (
                <Typography variant="caption" color="text.tertiary" noWrap>
                  {params.row.description}
                </Typography>
              ) : (
                <Typography variant="caption" color="text.tertiary" noWrap>
                  {" ​"}
                </Typography>
              )}
            </Box>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: 'category_name',
      minWidth: 120,
      headerName: t('tasks:data_grid.columns.category'),
      renderCell: (params) => <CategoryCell value={params.value} row={params.row} />,
    },
    {
      field: 'state',
      minWidth: 120,
      headerName: t('tasks:data_grid.columns.status'),
      renderCell: (params) => <StateCell value={params.value} row={params.row} />,
    },
    {
      field: 'priority',
      minWidth: 120,
      headerName: t('tasks:data_grid.columns.priority'),
      renderCell: (params) => <PriorityCell value={params.value} row={params.row} />,
    },
    {
      field: 'assignees',
      headerName: t('tasks:data_grid.columns.assignees'),
      flex: 0.9,
      sortable: false,
      filterable: false,
      renderCell: (params) => <AssigneeCell row={params.row} />,
      cellClassName: 'no-padding-cell',
      sx: {
        padding: 0
      }
    },
    {
      field: 'due_date',
      headerName: t('tasks:data_grid.columns.due'),
      flex: 0.65,
      minWidth: 160,
      type: 'date',
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (params) => <DateCell value={params.value} label={t('tasks:data_grid.columns.due')} row={params.row} />,
    },
    {
      field: 'deadline',
      headerName: t('tasks:data_grid.columns.deadline'),
      flex: 1,
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => <DeadlineCell row={params.row} />,
    },
    {
      field: 'actions',
      // headerName: t('tasks:data_grid.columns.actions'),
      headerName: "",
      width: 85,
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (params) => (
        <ActionsCell
          row={params.row}
          canUpdate={canUpdate}
          canDelete={canDelete}
          canChangeState={canChangeState}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
          onStateChange={onStateChange}
        />
      ),
    },
  ];
};